import { render, staticRenderFns } from "./sidebar-disclaimers.vue?vue&type=template&id=f4e971aa&scoped=true"
import script from "./sidebar-disclaimers.vue?vue&type=script&lang=js"
export * from "./sidebar-disclaimers.vue?vue&type=script&lang=js"
import style0 from "./sidebar-disclaimers.vue?vue&type=style&index=0&id=f4e971aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e971aa",
  null
  
)

export default component.exports